export default __webpack_public_path__ + "static/media/upload.8947c907.svg";